// Authenticated file download.
//
// Every download route (audit/proposal PDFs, staff and client) is behind
// HTTPBearer, which only reads the Authorization header. window.open() and
// <a href> can't send that header - and nothing on the backend reads a
// ?token= query param - so those just opened a {"detail":"Not authenticated"}
// tab. Fetch the file with the header instead and hand the browser a
// temporary object URL to save.
export async function downloadFile(url, token, filename) {
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) {
    let detail = "";
    try {
      detail = (await res.json()).detail;
    } catch {
      // Non-JSON error body - fall back to the status code below.
    }
    throw new Error(typeof detail === "string" && detail ? detail : `Download failed (${res.status})`);
  }
  const blob = await res.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoke on the next tick so the browser has picked up the download first.
  setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0);
}
